import { Button, Col, Row, Container, Table } from 'react-bootstrap';
import LoadingButton from '../skeletons/loadingButton';
import toast, { Toaster } from "react-hot-toast";
import { useState, useEffect } from 'react';
import '../css/common.css';
import '../css/hover.css'
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { saveForm, deleteForm } from '../store/Slices/formSlice';
import { generateLoa } from '../store/Slices/generateSlice';
import useValidation from '../helpers/validation';
import { getCitiesAndZips } from '../helpers/citiesAndZipsGermany';
import { getCitiesAndAreas } from '../helpers/citiesAndAreasGermany';
import * as XLSX from 'xlsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUpload, faTrash, faDownload } from '@fortawesome/free-solid-svg-icons';

const citiesAndZips = getCitiesAndZips(); // Get cities and zips from helper function
const citiesAndAreas = getCitiesAndAreas(); // Get cities and areas from helper function

function Germany() {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const userEmail = sessionStorage.getItem('email');
    const generateLoading = useSelector((state) => state.generate.loading);

    useEffect(() => {
        const fetchData = async () => {
            if (!userEmail) {
                navigate('/');
                return;
            }
            const form = JSON.parse(localStorage.getItem('form'));

            if (form?.country?.country === 'Germany') {
                fillForm(form);
            }
        };

        fetchData();
    }, [dispatch, navigate]);

    const { validateInput, validationStates, setValidationStates } = useValidation();

    const [nameCompany, setNameCompany] = useState();
    const [street, setStreet] = useState();
    const [fName, setFName] = useState();

    const [city, setCity] = useState('');
    const [area, setArea] = useState("");
    const [zip, setZip] = useState("");

    const [searchQuery, setSearchQuery] = useState('');
    const [filteredCities, setFilteredCities] = useState(citiesAndZips);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const [cityError, setCityError] = useState(false);


    const [number, setNumber] = useState();
    const [necessaryAct, setNecessaryAct] = useState();
    const [loosingCarrier, setLoosingCarrier] = useState();

    const [portDate, setPortDate] = useState();


    //-----------------------------------------------FillForm-------------------------------------------------//

    const fillForm = (form) => {
        const JSONData = form;
        document.querySelector('#nameCompany').value = JSONData?.country?.customerDetails?.name ?? '';
        document.querySelector('#fName').value = JSONData?.country?.customerDetails?.firstName ?? '';
        document.querySelector('#street').value = JSONData?.country?.customerDetails?.street ?? '';
        document.querySelector('#zip').value = JSONData?.country?.customerDetails?.zip ?? '';
        document.querySelector('#city').value = JSONData?.country?.customerDetails?.city ?? '';
        document.querySelector('#number').value = JSONData?.country?.customerDetails?.number ?? '';
        setNameCompany(JSONData?.country?.customerDetails?.name ?? '');
        setFName(JSONData?.country?.customerDetails?.firstName ?? '');
        setStreet(JSONData?.country?.customerDetails?.street ?? '');
        setZip(JSONData?.country?.customerDetails?.zip ?? '');
        setCity(JSONData?.country?.customerDetails?.city ?? '');
        setNumber(JSONData?.country?.customerDetails?.number ?? '');

        document.querySelector('#necessaryAct').value = JSONData?.country?.portingDetails?.leasedLine ?? '';
        document.querySelector('#portDate').value = JSONData?.country?.portingDetails?.date ?? '';
        setNecessaryAct(JSONData?.country?.portingDetails?.leasedLine ?? '');
        setPortDate(JSONData?.country?.portingDetails?.date ?? '');

        const pWindow = JSONData?.country?.portingDetails?.portingWindow;
        if (pWindow?.time === '06:00-08:00' || pWindow?.time === '06:00-12:00') {
            document.querySelector('#port').value = pWindow?.time;
            setSelectedOption(pWindow?.time);
        } else {
            document.querySelector('#port').value = 'other';
            setSelectedOption('other');
        }
        setFormData(JSONData?.country?.portingDetails?.portingWindow ?? {});

        if (JSONData?.country?.numberType?.numberType?.singleNumPort) {
            setSelectedOptionNumType('singleNumber');
            document.querySelector('#type').value = 'singleNumber';
        }
        else if (JSONData?.country?.numberType?.numberType?.numberRange) {
            setSelectedOptionNumType('numberRange');
            document.querySelector('#type').value = 'numberRange';

            setTimeout(() => {
                const areaRange = document.querySelector('#areaRange');
                const didRange = document.querySelector('#didRange');
                const switchRange = document.querySelector('#switchRange');
                // const extStartRange = document.querySelector('#extStartRange');
                // const extEndRange = document.querySelector('#extEndRange');

                if (areaRange) areaRange.value = JSONData?.country?.numberType?.numberType?.area ?? '';
                if (didRange) didRange.value = JSONData?.country?.numberType?.numberType?.did ?? '';
                if (switchRange) switchRange.value = JSONData?.country?.numberType?.numberType?.switch ?? '';
                // if (extStartRange) extStartRange.value = JSONData?.country?.numberType?.numberType?.extStart ?? '';
                // if (extEndRange) extEndRange.value = JSONData?.country?.numberType?.numberType?.extEnd ?? '';
            }, 0);

        }

        setFormDataNumType(JSONData?.country?.numberType?.numberType ?? {});

        document.querySelector('#loosingCarrier').value = JSONData?.country?.carrier?.carrier ?? '';
        setLoosingCarrier(JSONData?.country?.carrier?.carrier ?? '');
    };


    //-----------------------------------------------Hover-------------------------------------------------//

    const [hoveredField, setHoveredField] = useState(null); //hovered field

    const handleMouseEnter = (field) => {
        setHoveredField(field);
    };

    const handleMouseLeave = () => {
        setHoveredField(null);
    };

    useEffect(() => {
        const savedForm = localStorage.getItem('form');
        if (savedForm) {
            const parsedForm = JSON.parse(savedForm);
            fillForm(parsedForm);
            setArea(parsedForm?.country?.numberType?.numberType?.area ?? '');
        }
    }, []);



    useEffect(() => {
        setFilteredCities(
            citiesAndZips.filter(item =>
                item.city.toLowerCase().includes(searchQuery.toLowerCase())
            )
        );
    }, [searchQuery]);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (isDropdownOpen && !event.target.closest('.dropdown-container')) {
                setIsDropdownOpen(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isDropdownOpen]);

    const handleCityChange = (selectedCity) => {
        setCity(selectedCity);

        const selectedCityZips = citiesAndZips.filter(item => item.city === selectedCity);
        const zipOptions = selectedCityZips.map(item => item.zip);
        const selectedCityAreaData = citiesAndAreas.find(item => item.city === selectedCity);
        const area = selectedCityAreaData ? selectedCityAreaData.area : '';

        setArea(area);
        setZip(zipOptions);

        setFormDataNumType(prevData => ({
            ...prevData,
            area: area,
        }));

        setValidationStates(prevState => ({
            ...prevState,
            zip: true,
            city: true,
        }));

        setIsDropdownOpen(false);
        setCityError(false);
    };


    const handleAreaChange = (e) => {
        const newArea = e.target.value;
        setArea(newArea); // Update the area state

        // Update formDataNumType with the new area
        setFormDataNumType(prevData => ({
            ...prevData,
            area: newArea // Update the area in formDataNumType
        }));
    };


    const handleInputChange1 = (e) => {
        const value = e.target.value;
        setSearchQuery(value);
        setCity(value); // Update city state as the user types

        // Clear error if input is empty
        if (value === '') {
            setCityError(false);
        }
    };

    const handleBlur = () => {
        // Check if the input is empty
        if (!city) {
            setCityError(true);
            toast.error("City is required! Please select the city from the dropdown below.");
        } else {
            // Validate the entered city against the list
            const isValidCity = citiesAndZips.some(item => item.city.toLowerCase() === city.toLowerCase());
            if (!isValidCity) {
                setCityError(true);
                toast.error("City is not valid!");
            } else {
                setCityError(false); // Clear error if the city is valid
            }
        }
    };

    //-------------------------code for rendering one section out of two (Porting Details)-------------------------//

    const [selectedOption, setSelectedOption] = useState('');
    const [formData, setFormData] = useState({

    });

    const handleDropdownChange = (e) => {
        setSelectedOption(e.target.value);
        // Reset form data when dropdown changes

        if (e.target.value === 'other') {
            setFormData({
                time: ""
            })
        }
        else if (e.target.value === '06:00-08:00') {
            setFormData({
                time: "06:00-08:00"
            })
        }
        else if (e.target.value === '06:00-12:00') {
            setFormData({
                time: "06:00-12:00"
            })
        }

        else {
            setFormData({

            })
        }

        setValidationStates(prev => ({
            ...prev,
            time: true // or `undefined` depending on your validation logic
        }));
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const renderFormInputs = () => {
        switch (selectedOption) {
            case 'other':
                return (
                    <div>

                        <Row>
                            <Col
                                onMouseEnter={() => handleMouseEnter('time')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Other*</label> <br />
                                <input
                                    onChange={handleInputChange}
                                    type="text"
                                    id='time'
                                    name='time'
                                    value={formData.time}
                                    placeholder=""
                                    className={`inputbox ${validationStates.time === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('time', /^[\w\W,]+$/)}
                                />
                                {hoveredField === 'time' && (
                                    <div className="hover-description">
                                        Enter the other porting window
                                    </div>
                                )}
                            </Col>

                        </Row>

                    </div>
                );
            case '06:00-08:00':
                return (
                    <div></div>
                );
            case '06:00-12:00':
                return (
                    <div></div>
                );
            default:
                return null;
        }
    };


    //-------------------------code for rendering one section out of two (Single Number Porting Form/Number type)-------------------------//

    const [selectedOptionNumType, setSelectedOptionNumType] = useState('');
    const [formDataNumType, setFormDataNumType] = useState({

    });

    const handleDropdownChangeNumType = (e) => {
        const selectedOption = e.target.value;
        setSelectedOptionNumType(selectedOption);

        // Reset form data when dropdown changes
        if (selectedOption === 'singleNumber') {
            setFormDataNumType({
                area: area,
                dropdown: "",
                singleNumPort: [{ id: Date.now(), Number: '' }]
            });
            setValidationStates({});

        } else if (selectedOption === 'numberRange') {
            setFormDataNumType({
                area: area,
                did: "",
                switch: "",
                numberRange: [{ id: Date.now(), sNumber: '', eNumber: '' }],
            });
            setValidationStates({});

        } else {
            setFormDataNumType({});
            setValidationStates({});
        }
    };

    const handleInputChangeNumType = (e) => {
        const { name, value } = e.target;
        setFormDataNumType({ ...formDataNumType, [name]: value });
    };

    const handleChange_table = (id, field, value) => {
        const updatedsingleNumPort = formDataNumType.singleNumPort.map((row) =>
            row.id === id ? { ...row, [field]: value } : row
        );
        setFormDataNumType((prevState) => ({
            ...prevState,
            singleNumPort: updatedsingleNumPort,
        }));
    };

    const addRow = () => {
        setFormDataNumType((prevState) => ({
            ...prevState,
            singleNumPort: [
                ...prevState.singleNumPort,
                { id: Date.now(), Number: '' },
            ],
        }));
    };

    const removeRow = (id) => {
        const updatedsingleNumPort = formDataNumType.singleNumPort.filter((row) => row.id !== id);
        setFormDataNumType((prevState) => ({
            ...prevState,
            singleNumPort: updatedsingleNumPort,
        }));
    };

    const handleChange_numberRange = (id, field, value) => {
        const updatedNumberRange = formDataNumType.numberRange.map((row) =>
            row.id === id ? { ...row, [field]: value } : row
        );
        setFormDataNumType((prevState) => ({
            ...prevState,
            numberRange: updatedNumberRange,
        }));
    };

    const addRow_numberRange = () => {
        setFormDataNumType((prevState) => ({
            ...prevState,
            numberRange: [
                ...prevState.numberRange,
                { id: Date.now(), sNumber: '', eNumber: '' },
            ],
        }));
    };

    const removeRow_numberRange = (id) => {
        const updatedNumberRange = formDataNumType.numberRange.filter((row) => row.id !== id);
        setFormDataNumType((prevState) => ({
            ...prevState,
            numberRange: updatedNumberRange,
        }));
    };

    const fileInputRef = React.createRef();  // Create a reference to the file input element
    const [uploadedFileName, setUploadedFileName] = useState('');

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        if (!file) return;

        setUploadedFileName(file.name);

        const reader = new FileReader();
        reader.onload = (e) => {
            const data = new Uint8Array(e.target.result);
            const workbook = XLSX.read(data, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];

            const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1, range: 4 });
            if (!jsonData.length) {
                toast.error('Uploaded file is empty or has an invalid format.');
                setUploadedFileName('');
                return;
            }

            const fileHeaders = jsonData[0] || [];
            const expectedHeaders = ['Public from', 'Public to', 'Private from', 'Private to', 'Local Country Value'];

            if (!expectedHeaders.every((header, index) => header === fileHeaders[index])) {
                toast.error('Uploaded file does not match the expected format.');
                setUploadedFileName('');
                return;
            }

            const dataRows = jsonData.slice(1);

            // ✅ LIMIT CHECK ADDED
            if (dataRows.length > 10) {
                toast.error('Only 10 number range entries are allowed in the uploaded file.');
                setUploadedFileName('');
                event.target.value = null; // reset file input
                return;
            }

            const formattedDataRange = dataRows.map((row, index) => ({
                id: index + 1,
                sNumber: row[0] ? row[0].toString() : '',
                eNumber: row[1] ? row[1].toString() : '',
            }));

            // Update table data
            setFormDataNumType(prev => ({
                ...prev,
                numberRange: formattedDataRange
            }));

            // Build new validation state
            const newValidationState = {};

            formattedDataRange.forEach(row => {
                const startValue = row.sNumber;
                const endValue = row.eNumber;

                newValidationState[`start-${row.id}`] = /^\d{1,8}$/.test(startValue);
                newValidationState[`end-${row.id}`] = /^\d{1,8}$/.test(endValue);

                if (!newValidationState[`start-${row.id}`]) {
                    //toast.error(`Start number in row ${row.id} must be between 1 to 8 digits.`);
                }
                if (!newValidationState[`end-${row.id}`]) {
                    //toast.error(`End number in row ${row.id} must be between 1 to 8 digits.`);
                }
            });

            // Apply validation state
            setValidationStates(prev => ({
                ...prev,
                ...newValidationState
            }));
        };

        reader.readAsArrayBuffer(file);
    };

    const removeUploadedFile = () => {
        setUploadedFileName('');
        fileInputRef.current.value = '';

        // Clear numberRange from formData
        setFormDataNumType(prev => ({
            ...prev,
            numberRange: [{ id: Date.now(), sNumber: '', eNumber: '' }]
        }));
    };

    const handleDownload = async () => {
        try {
            // Fetch the file (portabilityImportTemplate.xlsx) from the server
            const response = await fetch(`/portabilityImportTemplate.xlsx?t=${new Date().getTime()}`);

            // Check if the response is valid
            if (!response.ok) throw new Error("Network response was not ok");

            // Convert the response to a Blob
            const blob = await response.blob();

            // Create a URL for the Blob to allow it to be downloaded
            const url = window.URL.createObjectURL(blob);

            // Create an anchor tag dynamically and trigger a click to download the file
            const a = document.createElement("a");
            a.href = url;
            a.download = "portabilityImportTemplate.xlsx"; // File name for download
            document.body.appendChild(a);
            a.click(); // Initiate the download
            document.body.removeChild(a); // Clean up by removing the anchor element
        } catch (error) {
            // Catch any error that occurs during the download process
            console.error("Download failed:", error);
        }
    };

    const renderFormInputsNumType = () => {
        switch (selectedOptionNumType) {
            case 'singleNumber':
                return (
                    <div>

                        <Row>

                            <Col
                                onMouseEnter={() => handleMouseEnter('area')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Area Code</label> <br />
                                <input
                                    onChange={handleAreaChange} // Use the new handler
                                    id="areaField"
                                    value={area} // Bind the input value to the area state
                                    type="text"
                                    className={`inputbox`}
                                />
                            </Col>

                            <br></br><br></br>

                            <Col
                                onMouseEnter={() => handleMouseEnter('dropdown')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Porting of all numbers*</label> <br />
                                <select
                                    onChange={handleInputChangeNumType}
                                    id='dropdownField'
                                    name='dropdown'
                                    className={`inputbox ${validationStates.dropdownField === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('dropdownField', /^[\w\W,]+$/)}
                                    value={formDataNumType.dropdown}
                                >
                                    <option value=""></option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                                {hoveredField === 'dropdown' && (
                                    <div className="hover-description">
                                        Select Yes or No
                                    </div>
                                )}
                            </Col>

                        </Row>

                        <br></br>

                        <Table striped bordered hover variant="light">
                            <thead>
                                <tr>
                                    <th>Number/MSN*</th>
                                </tr>
                            </thead>
                            <tbody>
                                {formDataNumType.singleNumPort.map(row => (
                                    <tr key={row.id}>

                                        <td
                                            onMouseEnter={() => handleMouseEnter(`num-${row.id}`)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <input
                                                type="text"
                                                id={`num-${row.id}`} // Dynamic ID for number input
                                                value={row.Number}
                                                onChange={(e) => handleChange_table(row.id, 'Number', e.target.value)}
                                                className={`inputbox ${validationStates[`num-${row.id}`] === false ? 'error' : ''}`}
                                                onBlur={() => {
                                                    // Validate for 3 to 8 digits
                                                    const isValid = /^\d{3,8}$/.test(row.Number);
                                                    if (!isValid) {
                                                        toast.error('Input must be between 3 to 8 digits.');
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`num-${row.id}`]: false,
                                                        }));
                                                    } else {
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`num-${row.id}`]: true,
                                                        }));
                                                    }
                                                }}
                                            />
                                            {hoveredField === `num-${row.id}` && (
                                                <div className="hover-description">
                                                    Enter the number in a range of 3 to 8 digits.
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            {formDataNumType.singleNumPort.length > 1 && (
                                                <button onClick={() => removeRow(row.id)}>Remove</button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>

                        <button onClick={addRow} disabled={formDataNumType.singleNumPort.length >= 10}>Add Row

                        </button>

                    </div>
                );
            case 'numberRange':
                return (
                    <div>

                        <Row>
                            <br></br><br></br>

                            <Col
                                onMouseEnter={() => handleMouseEnter('area')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Area Code*</label> <br />
                                <input
                                    onChange={handleAreaChange} // Use the new handler
                                    id="areaRange"
                                    value={area} // Bind the input value to the area state
                                    type="text"
                                    className={`inputbox ${validationStates.areaRange === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('areaRange', /^\d{2,5}$/)}
                                />
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('did')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>DID*</label> <br />
                                <input
                                    onChange={handleInputChangeNumType}
                                    type="text"
                                    id='didRange'
                                    name='did'
                                    placeholder=""
                                    className={`inputbox ${validationStates.didRange === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('didRange', /^[0-9]+$/)}
                                />
                                {hoveredField === 'did' && (
                                    <div className="hover-description">
                                        Enter the main line number (minimum 1 digit)
                                    </div>
                                )}
                            </Col>

                            <Col
                                onMouseEnter={() => handleMouseEnter('switch')}
                                onMouseLeave={handleMouseLeave}
                            >
                                <label>Switchboard*</label> <br />
                                <input
                                    onChange={handleInputChangeNumType}
                                    type="text"
                                    id='switchRange'
                                    name='switch'
                                    placeholder=""
                                    className={`inputbox ${validationStates.switchRange === false ? 'error' : ''}`}
                                    onBlur={() => validateInput('switchRange', /^\d{1,4}$/)}
                                />
                                {hoveredField === 'switch' && (
                                    <div className="hover-description">
                                        Enter the Switchboard Number in a range of 1 to 4 digits.
                                    </div>
                                )}
                                <br></br><br></br>
                            </Col>

                        </Row>

                        <br></br>

                        <Row>
                            <Col>
                                <button
                                    variant="secondary"
                                    className="inputbox"
                                    style={{ alignItems: 'center' }}
                                    onClick={() => fileInputRef.current.click()}
                                >
                                    <FontAwesomeIcon icon={faUpload} style={{ marginRight: '8px' }} />
                                    Upload File
                                </button>
                                <input
                                    id="fileUploadInput"
                                    type="file"
                                    accept=".xlsx, .xls"
                                    onChange={handleFileUpload}
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                />
                            </Col>

                            <Col>
                                <button className="inputbox" onClick={handleDownload} style={{ alignItems: 'center' }}>
                                    <FontAwesomeIcon icon={faDownload} style={{ marginRight: '8px' }} />
                                    Download number range template
                                </button>
                            </Col>

                            <Col>
                                {uploadedFileName && (
                                    <button onClick={removeUploadedFile} className="inputbox" style={{ alignItems: 'center' }}>
                                        <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                                        Remove
                                    </button>
                                )}
                            </Col>
                        </Row>

                        <Row>
                            <Col>
                                {uploadedFileName && (
                                    <div style={{ display: 'flex', alignItems: 'center', marginTop: '10px' }}>
                                        <p style={{ marginRight: '10px' }}>Uploaded File: {uploadedFileName}</p>
                                    </div>
                                )}
                            </Col>
                        </Row>

                        <br />
                        <p>The template is the same used for the btd portability request.</p>
                        <br />

                        <Table striped bordered hover variant="light">
                            <br></br>
                            <thead>
                                <tr>
                                    <th>Extension Range Start*</th>
                                    <th>Extension Range Stop*</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {formDataNumType.numberRange.map(row => (
                                    <tr key={row.id}>
                                        <td
                                            onMouseEnter={() => handleMouseEnter(`start-${row.id}`)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <input
                                                type="text"
                                                id={`start-${row.id}`}
                                                value={row.sNumber}
                                                onChange={(e) => handleChange_numberRange(row.id, 'sNumber', e.target.value)}
                                                className={`inputbox ${validationStates[`start-${row.id}`] === false ? 'error' : ''}`}
                                                onBlur={() => {
                                                    const isValid = /^\d{1,8}$/.test(row.sNumber);
                                                    if (!isValid) {
                                                        toast.error('Start number must be between 1 to 8 digits.');
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`start-${row.id}`]: false,
                                                        }));
                                                    } else {
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`start-${row.id}`]: true,
                                                        }));
                                                    }
                                                }}
                                            />
                                            {hoveredField === `start-${row.id}` && (
                                                <div className="hover-description">
                                                    Enter the start number (1 to 8 digits).
                                                </div>
                                            )}
                                        </td>
                                        <td
                                            onMouseEnter={() => handleMouseEnter(`end-${row.id}`)}
                                            onMouseLeave={handleMouseLeave}
                                        >
                                            <input
                                                type="text"
                                                id={`end-${row.id}`}
                                                value={row.eNumber}
                                                onChange={(e) => handleChange_numberRange(row.id, 'eNumber', e.target.value)}
                                                className={`inputbox ${validationStates[`end-${row.id}`] === false ? 'error' : ''}`}
                                                onBlur={() => {
                                                    const isValid = /^\d{1,8}$/.test(row.eNumber);
                                                    if (!isValid) {
                                                        toast.error('End number must be between 1 to 8 digits.');
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`end-${row.id}`]: false,
                                                        }));
                                                    } else {
                                                        setValidationStates(prev => ({
                                                            ...prev,
                                                            [`end-${row.id}`]: true,
                                                        }));
                                                    }
                                                }}
                                            />
                                            {hoveredField === `end-${row.id}` && (
                                                <div className="hover-description">
                                                    Enter the end number (1 to 8 digits).
                                                </div>
                                            )}
                                        </td>
                                        <td>
                                            {formDataNumType.numberRange.length > 1 && (
                                                <button onClick={() => removeRow_numberRange(row.id)}>Remove</button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <button onClick={addRow_numberRange} disabled={formDataNumType.numberRange.length >= 10}>Add Row

                        </button>

                    </div>
                );

            default:
                return null;
        }
    };

    //-------------------------------------------creating Schema----------------------------------------//

    const json = {
        "country": {
            "country": "Germany",
            // "orderDetails": {
            //     "LOIS": ref
            // },
            "customerDetails": {
                "name": nameCompany,
                "firstName": fName,
                "street": street,
                "number": number,
                "zip": zip,
                "city": city
            },
            "portingDetails": {
                "leasedLine": necessaryAct,
                "date": portDate,
                "portingWindow": formData
            },
            "numberType": {
                "numberType": formDataNumType
            },
            "carrier": {
                "carrier": loosingCarrier
            }
        },
        "email": sessionStorage.getItem('email'),
    };

    // Convert the JSON object to a JSON string
    const jsonString = JSON.stringify(json);

    // Output the JSON string
    // console.log(jsonString);

    //-----------------------------------------sending request---------------------------------------------//

    async function Submit(e) {
        e.preventDefault();

        let validationErrors = {};

        // Validate each field and set validation error with specific messages
        if (!nameCompany) {
            validationErrors.nameCompany = 'Please fill in the company name.';
        }
        if (!street) {
            validationErrors.street = 'Please fill in the street name.';
        }
        if (!number) {
            validationErrors.number = 'Please fill in the street number.';
        }
        if (!city) {
            validationErrors.city = 'Please fill in the city name.';
            setCityError(true);
        } else {
            const isValidCity = citiesAndZips.some(item => item.city.toLowerCase() === city.toLowerCase());
            if (!isValidCity) {
                validationErrors.city = 'City is not valid. Please select it from the dropdown.';
                setCityError(true);
            } else {
                setCityError(false);

                setValidationStates(prev => ({
                    ...prev,
                    city: true,
                }));
            }
        }
        if (!zip) {
            validationErrors.zip = 'Please fill in the ZIP code.';
        }
        if (!necessaryAct) {
            validationErrors.necessaryAct = 'Please specify whether leased line needs to be cancelled or not.';
        }
        if (!portDate) {
            validationErrors.portDate = 'Please specify a porting date.';
        }
        if (!selectedOption) {
            validationErrors.port = 'Please select a porting window.';
        }
        if (selectedOption === 'other') {
            if (!formData.time) {
                validationErrors.time = 'Please specify the porting window.';
            }
        }
        if (!selectedOptionNumType) {
            validationErrors.type = 'Please specify number type.';
        }
        if (selectedOptionNumType) {
            if (selectedOptionNumType === 'singleNumber') {

                if (!formDataNumType.dropdown) {
                    validationErrors.dropdownField = 'Please specify porting of all numbers is required or not.';
                }
                formDataNumType.singleNumPort.forEach((row, index) => {
                    if (!row.Number || !/^\d{3,8}$/.test(row.Number)) {
                        validationErrors[`num-${row.id}`] = `Please fill in a number for row ${index + 1} in the number table.`;
                    }
                });
            } else if (selectedOptionNumType === 'numberRange') {
                if (!formDataNumType.area) {
                    validationErrors.areaRange = 'Please fill in the area code.';
                }
                if (!formDataNumType.did) {
                    validationErrors.didRange = 'Please fill in the DID.';
                }
                if (!formDataNumType.switch) {
                    validationErrors.switchRange = 'Please fill in the switchboard.';
                }
                formDataNumType.numberRange.forEach((row, index) => {
                    if (!row.sNumber || !/^\d{1,8}$/.test(row.sNumber)) {
                        validationErrors[`start-${row.id}`] = `Please fill in a valid start number for row ${index + 1} in the number range table.`;
                    }
                    if (!row.eNumber || !/^\d{1,8}$/.test(row.eNumber)) {
                        validationErrors[`end-${row.id}`] = `Please fill in a valid end number for row ${index + 1} in the number range table.`;
                    }
                });
            }
        }
        if (!loosingCarrier) {
            validationErrors.loosingCarrier = 'Please specify one losing carrier.';
        }

        // Check if there are any validation errors
        const hasValidationError = Object.values(validationErrors).length > 0;

        if (hasValidationError) {
            // Update validation states
            setValidationStates(prevState => ({
                ...prevState,
                ...Object.keys(validationErrors).reduce((acc, key) => {
                    acc[key] = false;
                    return acc;
                }, {})
            }));

            // Show the first error message
            const firstError = Object.values(validationErrors)[0];
            const firstErrorKey = Object.keys(validationErrors)[0];
            document.getElementById(firstErrorKey).scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(firstError);
            return;
        }

        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => value === false)
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            toast.error(`Please make sure fields in red are correct. \n${falseKeys} `);
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            return;
        }

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/generate_loa`, {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(json) // Ensure you are stringifying the object here
            });

            if (!response.ok) {
                throw new Error('Network response was not correct');
            }

            const blobData = await response.blob();
            const url = URL.createObjectURL(blobData);
            const a = document.createElement('a');

            // Check if fName is available; otherwise, fallback to the country name
            const fileName = fName ? `${fName}-LOA.pdf` : `${json.country.country}-LOA.pdf`;

            a.href = url;
            a.download = fileName; // Use the fileName logic above
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error downloading file : ', error);
            // toast.error("An error occurred while processing your request.");
            window.location.href = 'https://my-service-space.orange-business.com/wacsmss/group/mssportal/home';
        }

    }

    //----------------------------------------------RESET--------------------------------------------------//

    async function Reset(e) {
        const dataToBeDeleted = { "email": userEmail };
        dispatch(deleteForm(dataToBeDeleted));
        localStorage.removeItem('form');
        window.location.reload();
    }

    async function save(e) {
        e.preventDefault();
        const falseKeys = Object.entries(validationStates)
            .filter(([key, value]) => {
                const element = document.getElementById(key);
                return value === false && element && element.value.trim() !== '';
            })
            .map(([key, value]) => key);

        if (falseKeys.length > 0) {
            const elem = document.getElementById(falseKeys[0]);
            elem.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
            toast.error(`Please make sure following fields in red are correct before saving `);
            return;
        }

        // Ensure the area code is included in the json object
        json.country.numberType.numberType.area = area;

        localStorage.setItem('form', JSON.stringify(json));
        const dataToBeSaved = { "email": userEmail, "json_data": json };
        try {
            const response = await dispatch(saveForm(dataToBeSaved));
            if (response?.payload?.message === "success") {
                toast.success('Form saved successfully');
            }
        } catch (error) {
            toast.error('There was an error processing your request.');
        }
    }

    //-----------------------------------------------JSX----------------------------------------------------//


    return (
        <div>

            <Toaster position="top-center" reverseOrder={false}></Toaster>

            <div className='french'>

                <Container>

                    <p><strong>Mandatory fields are marked by *</strong></p> <br></br>

                    <h2 className='heading'>Customer Details</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('nameCompany')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Name/Company*</label> <br />
                            <input
                                onChange={(e) => setNameCompany(e.target.value)}
                                type="text"
                                id="nameCompany"
                                placeholder=""
                                className={`inputbox ${validationStates.nameCompany === false ? 'error' : ''}`}
                                onBlur={() => validateInput('nameCompany', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'nameCompany' && (
                                <div className="hover-description">
                                    Enter the Name/Company
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('fName')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>First Name</label> <br />
                            <input
                                onChange={(e) => setFName(e.target.value)}
                                type="text"
                                id="fName"
                                placeholder=""
                                className={`inputbox`}
                            // onBlur={() => validateInput('fName', /^[A-Za-z]+$/)}
                            />
                            {hoveredField === 'fName' && (
                                <div className="hover-description">
                                    Enter the First Name
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('street')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Street Name*</label> <br />
                            <input
                                onChange={(e) => setStreet(e.target.value)}
                                type="text"
                                id="street"
                                placeholder=""
                                className={`inputbox ${validationStates.street === false ? 'error' : ''}`}
                                onBlur={() => validateInput('street', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'street' && (
                                <div className="hover-description">
                                    Enter the Street Name(e.g. Hauptstrasse, Main Street)
                                </div>
                            )}
                        </Col>

                    </Row>

                    <br />

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('number')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Street Number*</label> <br />
                            <input
                                onChange={(e) => setNumber(e.target.value)}
                                type="text"
                                id="number"
                                placeholder=""
                                className={`inputbox ${validationStates.number === false ? 'error' : ''}`}
                                onBlur={() => validateInput('number', /^[\w\W,]+$/)}
                            />
                            {hoveredField === 'number' && (
                                <div className="hover-description">
                                    Enter the Street Number (e.g. 111 b)
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('city')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>City*</label>
                            <div style={{ position: 'relative' }} className="dropdown-container">
                                <input
                                    id="city"
                                    type="text"
                                    placeholder="Search City..."
                                    autocomplete="off"
                                    inputmode="none"
                                    value={city}
                                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                                    onChange={handleInputChange1}
                                    onBlur={handleBlur}
                                    className={`inputbox ${cityError ? 'error' : ''}`} // Ensure your CSS styles this correctly
                                />
                                {cityError && <div style={{ color: 'red' }}>{!city ? "City is required" : "City is not valid"}</div>}
                                {isDropdownOpen && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '100%',
                                        left: 0,
                                        right: 0,
                                        border: '1px solid #ccc',
                                        backgroundColor: '#fff',
                                        zIndex: 1000,
                                        maxHeight: '150px',
                                        overflowY: 'auto',
                                    }} tabIndex={-1}>
                                        {filteredCities.length > 0 ? (
                                            [...new Set(filteredCities.map(({ city }) => city))].map((uniqueCity) => (
                                                <div
                                                    key={uniqueCity}
                                                    onMouseDown={() => handleCityChange(uniqueCity)}
                                                    style={{
                                                        padding: '8px',
                                                        cursor: 'pointer',
                                                        backgroundColor: '#fff',
                                                    }}
                                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                                >
                                                    {uniqueCity}
                                                </div>
                                            ))
                                        ) : (
                                            <div style={{ padding: '8px' }}>No cities found</div>
                                        )}
                                    </div>
                                )}
                            </div>
                        </Col>

                        <Col onMouseEnter={() => handleMouseEnter('zip')} onMouseLeave={handleMouseLeave}>
                            <label>Zip Code*</label> <br />
                            {Array.isArray(zip) && zip.length > 1 ? (
                                <select
                                    id="zip"
                                    autocomplete="off"
                                    inputmode="none"
                                    className={`inputbox ${(validationStates.zip === false || cityError) ? 'error' : ''} zip-input`}
                                    onBlur={() => validateInput('zip', /^.*$/)}
                                    onChange={(e) => {
                                        setZip(e.target.value);
                                        // Reset the error when zip code is selected
                                        setValidationStates(prevState => ({
                                            ...prevState,
                                            zip: true, // Reset the error state
                                        }));
                                    }}
                                    style={{ backgroundColor: '#f5f5f5' }}
                                >
                                    <option value="">Select Zip Code</option>
                                    {zip.map((zipCode, index) => (
                                        <option key={index} value={zipCode}>{zipCode}</option>
                                    ))}
                                </select>
                            ) : (
                                <input
                                    id="zip"
                                    value={zip.length === 1 ? zip[0] : zip} // Display the zip code if only one is available
                                    readOnly
                                    type="text"
                                    className={`inputbox ${(validationStates.zip === false || cityError) ? 'error' : ''} zip-input`}
                                    style={{ backgroundColor: '#f5f5f5', cursor: 'not-allowed' }}
                                />
                            )}
                        </Col>

                    </Row>

                    <br></br>

                </Container>

                <br></br>

                <Container>

                    <h2 className='heading'>Porting Details</h2> <br></br>

                    <Row>

                        <Col
                            onMouseEnter={() => handleMouseEnter('necessaryAct')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Leased line to be canceled*</label> <br />
                            <select
                                id="necessaryAct"
                                onChange={(e) => setNecessaryAct(e.target.value)}
                                className={`inputbox ${validationStates.necessaryAct === false ? 'error' : ''}`}
                                onBlur={() => validateInput('necessaryAct', /^.*$/)}
                            >
                                <option value=""></option>
                                <option value="Yes">
                                    Yes
                                </option>
                                <option value="No">
                                    No
                                </option>
                            </select>
                            {hoveredField === 'necessaryAct' && (
                                <div className="hover-description">
                                    Leased line to be canceled with the porting order
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('portDate')}
                            onMouseLeave={handleMouseLeave}
                        >
                            <label>Designated Porting Date*</label> <br />
                            <input
                                onChange={(e) => setPortDate(e.target.value)}
                                type="date"
                                id="portDate"
                                placeholder=""
                                className={`inputbox ${validationStates.portDate === false ? 'error' : ''}`}
                                onBlur={() => validateInput('portDate', /^[\w\W,]+$/)}
                                min={new Date(new Date().setDate(new Date().getDate() + 1)).toISOString().split('T')[0]} // Disable today and past dates
                            />
                            {hoveredField === 'portDate' && (
                                <div className="hover-description">
                                    Enter the designated porting date
                                </div>
                            )}
                        </Col>

                        <Col
                            onMouseEnter={() => handleMouseEnter('port')}
                            onMouseLeave={handleMouseLeave}
                        >

                            <label>Porting Window*</label> <br></br>
                            <select id="port" value={selectedOption}
                                onChange={handleDropdownChange}
                                className={`inputbox ${validationStates.port === false ? 'error' : ''}`}
                                onBlur={() => validateInput('port', /^.*$/)}
                            >
                                <option value=""></option>
                                <option value="06:00-08:00">06:00-08:00</option>
                                <option value="06:00-12:00">06:00-12:00</option>
                                <option value="other">Other</option>
                            </select>
                            {hoveredField === 'port' && (
                                <div className="hover-description">
                                    The standard time for the porting window is 06:00-08:00.
                                </div>
                            )}
                            <br></br>
                            {renderFormInputs()}
                        </Col>

                    </Row>

                </Container>

                <br></br> <br></br>

                <Container>

                    <h2 className='heading'>Number Type</h2> <br></br>

                    <Row>

                        <Col>
                            <label>Number Type*</label> <br></br>
                            <select id="type"
                                value={selectedOptionNumType}
                                onChange={handleDropdownChangeNumType}
                                className={`inputbox ${validationStates.type === false ? 'error' : ''}`}
                                onBlur={() => validateInput('type', /^.*$/)}
                            >
                                <option value=""></option>
                                <option value="singleNumber">Single Number</option>
                                <option value="numberRange">Number Range</option>
                            </select>
                            <br></br><br></br>
                            {renderFormInputsNumType()}
                        </Col>

                    </Row>

                    <br />

                </Container>

                <br></br>

                <Container>

                    <h2 className='heading'>Loosing Carrier*</h2> <br></br>

                    <Col xs={8}
                        onMouseEnter={() => handleMouseEnter('loosingCarrier')}
                        onMouseLeave={handleMouseLeave}
                    >
                        <label>Select current provider(Loosing Carrier)</label> <br />
                        <select
                            id="loosingCarrier"
                            onChange={(e) => setLoosingCarrier(e.target.value)}
                            className={`inputbox ${validationStates.loosingCarrier === false ? 'error' : ''}`}
                            onBlur={() => validateInput('loosingCarrier', /^.*$/)}
                        >
                            <option value=""></option>
                            <option value="carrier name">Carrier Name</option>
                            <option value="[netzquadrat]">[netzquadrat]</option>
                            <option value="010090 GmbH">010090 GmbH</option>
                            <option value="01018 GmbH">01018 GmbH</option>
                            <option value="01024 Telefondienste GmbH">01024 Telefondienste GmbH</option>
                            <option value="01026 Telecom GmbH & Co. KG">01026 Telecom GmbH & Co. KG</option>
                            <option value="01029 Telecom GmbH">01029 Telecom GmbH</option>
                            <option value="01030 Telecom GmbH">01030 Telecom GmbH</option>
                            <option value="01037 Telecom GmbH">01037 Telecom GmbH</option>
                            <option value="01048 Telecom UG">01048 Telecom UG</option>
                            <option value="01049 GmbH (ehem. ETH)">01049 GmbH (ehem. ETH)</option>
                            <option value="01051 Telecom GmbH">01051 Telecom GmbH</option>
                            <option value="01054 Telecom GmbH">01054 Telecom GmbH</option>
                            <option value="01057 Protel GmbH">01057 Protel GmbH</option>
                            <option value="01058 Telecom GmbH">01058 Telecom GmbH</option>
                            <option value="01059 GmbH">01059 GmbH</option>
                            <option value="01071 Telecom GmbH">01071 Telecom GmbH</option>
                            <option value="01081 Telecom GmbH (ehem.01035)">01081 Telecom GmbH (ehem.01035)</option>
                            <option value="3U TELECOM GmbH">3U TELECOM GmbH</option>
                            <option value="acoreus AG">acoreus AG</option>
                            <option value="Alnitak GmbH">Alnitak GmbH</option>
                            <option value="Arcinum GmbH">Arcinum GmbH</option>
                            <option value="AS-Infodienste GmbH">AS-Infodienste GmbH</option>
                            <option value="BITel Gesellschaft für kommunale">BITel Gesellschaft für kommunale</option>
                            <option value="bn:t Blatzheim Networks Telecom GmbH">bn:t Blatzheim Networks Telecom GmbH</option>
                            <option value="Broadnet Services GmbH">Broadnet Services GmbH</option>
                            <option value="BT (Germany) GmbH & Co. OHG">BT (Germany) GmbH & Co. OHG</option>
                            <option value="Callax Mobilfunk GmbH">Callax Mobilfunk GmbH</option>
                            <option value="CALLAX Telecom Holding GmbH">CALLAX Telecom Holding GmbH</option>
                            <option value="CityKom Münster GmbH">CityKom Münster GmbH</option>
                            <option value="Colt Technology Services GmbH">Colt Technology Services GmbH</option>
                            <option value="Communication Services Tele2 GmbH">Communication Services Tele2 GmbH</option>
                            <option value="Datel">Datel</option>
                            <option value="Dialmex GmbH">Dialmex GmbH</option>
                            <option value="Discount Telecom S&V GmbH">Discount Telecom S&V GmbH</option>
                            <option value="DNS:NET Internet Service GmbH">DNS:NET Internet Service GmbH</option>
                            <option value="DOKOM">DOKOM</option>
                            <option value="Dritte HanseStar UG">Dritte HanseStar UG</option>
                            <option value="dtms Deutsche Telefon- und">dtms Deutsche Telefon- und</option>
                            <option value="eco Service GmbH">eco Service GmbH</option>
                            <option value="envia TEL GmbH">envia TEL GmbH</option>
                            <option value="E-Plus Mobilfunk GmbH & Co. KG">E-Plus Mobilfunk GmbH & Co. KG</option>
                            <option value="EWE TEL GmbH">EWE TEL GmbH</option>
                            <option value="EWE TEL GmbH (ehemals nordcom)">EWE TEL GmbH (ehemals nordcom)</option>
                            <option value="Exacor GmbH">Exacor GmbH</option>
                            <option value="First Communication GmbH">First Communication GmbH</option>
                            <option value="First Telecom GmbH">First Telecom GmbH</option>
                            <option value="Forester GmbH">Forester GmbH</option>
                            <option value="freenet Cityline GmbH">freenet Cityline GmbH</option>
                            <option value="HeLi NET Telekommunikation GmbH & Co. KG">HeLi NET Telekommunikation GmbH & Co. KG</option>
                            <option value="HLkomm Telekommunikations GmbH">HLkomm Telekommunikations GmbH</option>
                            <option value="HNS UG">HNS UG</option>
                            <option value="HSE Medianet GmbH">HSE Medianet GmbH</option>
                            <option value="htp GmbH">htp GmbH</option>
                            <option value="inexio Informationstechnologie und">inexio Informationstechnologie und</option>
                            <option value="IN-telegence GmbH">IN-telegence GmbH</option>
                            <option value="Jetz! Kommunikation GmbH & Co. KG">Jetz! Kommunikation GmbH & Co. KG</option>
                            <option value="Kabel Baden-Württemberg GmbH & Co. KG">Kabel Baden-Württemberg GmbH & Co. KG</option>
                            <option value="Kabel Deutschland">Kabel Deutschland</option>
                            <option value="KielNET GmbH">KielNET GmbH</option>
                            <option value="Kube & Au GmbH">Kube & Au GmbH</option>
                            <option value="LineCall Telecom GmbH">LineCall Telecom GmbH</option>
                            <option value="Maestro Telecom GmbH">Maestro Telecom GmbH</option>
                            <option value="MaterniSiebzehn GmbH">MaterniSiebzehn GmbH</option>
                            <option value="mcn tele.com AG">mcn tele.com AG</option>
                            <option value="Median Telecom GmbH">Median Telecom GmbH</option>
                            <option value="meetyoo conferencing GmbH">meetyoo conferencing GmbH</option>
                            <option value="MEGA Communications GmbH">MEGA Communications GmbH</option>
                            <option value="M-net (ehemals AugustaKom)">M-net (ehemals AugustaKom)</option>
                            <option value="M-net Telekommunikations GmbH">M-net Telekommunikations GmbH</option>
                            <option value="M-net Telekommunikations GmbH ehe.NEFkom">M-net Telekommunikations GmbH ehe.NEFkom</option>
                            <option value="mobileExtension GmbH">mobileExtension GmbH</option>
                            <option value="mr. next id technologies GmbH">mr. next id technologies GmbH</option>
                            <option value="mr.net group GmbH & Co. KG">mr.net group GmbH & Co. KG</option>
                            <option value="multiConnect GmbH">multiConnect GmbH</option>
                            <option value="NetAachen GmbH">NetAachen GmbH</option>
                            <option value="NetCologne GmbH">NetCologne GmbH</option>
                            <option value="NEXNET GmbH">NEXNET GmbH</option>
                            <option value="one4one Service GmbH (ehem.intelicom)">one4one Service GmbH (ehem.intelicom)</option>
                            <option value="OneTel Telecommunication GmbH">OneTel Telecommunication GmbH</option>
                            <option value="OpenNumbers eG">OpenNumbers eG</option>
                            <option value="Orange Business Germany GmbH">Orange Business Germany GmbH</option>
                            <option value="Osnatel GmbH">Osnatel GmbH</option>
                            <option value="outbox AG">outbox AG</option>
                            <option value="Pennyphone GmbH">Pennyphone GmbH</option>
                            <option value="PeterPays AG">PeterPays AG</option>
                            <option value="PfalzKom">PfalzKom</option>
                            <option value="PLANinterNET VoIP-GmbH">PLANinterNET VoIP-GmbH</option>
                            <option value="purpur networks GmbH">purpur networks GmbH</option>
                            <option value="QSC AG">QSC AG</option>
                            <option value="sdt.net AG">sdt.net AG</option>
                            <option value="SEC Service AG (inaktiv)">SEC Service AG (inaktiv)</option>
                            <option value="sms eSolutions GmbH">sms eSolutions GmbH</option>
                            <option value="Spider Telecom GmbH">Spider Telecom GmbH</option>
                            <option value="Telecall Services GmbH">Telecall Services GmbH</option>
                            <option value="TELEflash GmbH">TELEflash GmbH</option>
                            <option value="Telefónica Germany (ehemals HanseNet)">Telefónica Germany (ehemals HanseNet)</option>
                            <option value="Telefónica Germany GmbH & Co. OHG">Telefónica Germany GmbH & Co. OHG</option>
                            <option value="Telegate AG">Telegate AG</option>
                            <option value="Telekom Deutschland GmbH">Telekom Deutschland GmbH</option>
                            <option value="Telemedia Connect GmbH">Telemedia Connect GmbH</option>
                            <option value="Telia International">Telia International</option>
                            <option value="telomax GmbH (ehem.Inphone AG)">telomax GmbH (ehem.Inphone AG)</option>
                            <option value="TROPOLYS Service GmbH">TROPOLYS Service GmbH</option>
                            <option value="Umbra Networks Gesellschaft">Umbra Networks Gesellschaft</option>
                            <option value="United Service Partners UG">United Service Partners UG</option>
                            <option value="Unitymedia NRW GmbH">Unitymedia NRW GmbH</option>
                            <option value="Ventelo GmbH">Ventelo GmbH</option>
                            <option value="Verizon Deutschland GmbH">Verizon Deutschland GmbH</option>
                            <option value="Versatel Nord GmbH">Versatel Nord GmbH</option>
                            <option value="Versatel Ost GmbH">Versatel Ost GmbH</option>
                            <option value="Versatel Ost GmbH (ehem. ChemTel)">Versatel Ost GmbH (ehem. ChemTel)</option>
                            <option value="Versatel Süd GmbH">Versatel Süd GmbH</option>
                            <option value="Versatel Süd GmbH ehem.Versatel Germany">Versatel Süd GmbH ehem.Versatel Germany</option>
                            <option value="Versatel West GmbH">Versatel West GmbH</option>
                            <option value="Versatel West GmbH (ehem. telelev)">Versatel West GmbH (ehem. telelev)</option>
                            <option value="Versatel West GmbH (ehemals CNE)">Versatel West GmbH (ehemals CNE)</option>
                            <option value="Versatel West GmbH (ehemals Meocom)">Versatel West GmbH (ehemals Meocom)</option>
                            <option value="Versatel West GmbH (ehemals TeleBel)">Versatel West GmbH (ehemals TeleBel)</option>
                            <option value="Vodafone D2 GmbH">Vodafone D2 GmbH</option>
                            <option value="Vodafone D2 GmbH (ehemals Arcor)">Vodafone D2 GmbH (ehemals Arcor)</option>
                            <option value="Voipax GmbH">Voipax GmbH</option>
                            <option value="Voxbone SA">Voxbone SA</option>
                            <option value="VSE NET GmbH">VSE NET GmbH</option>
                            <option value="wilhelm.tel GmbH">wilhelm.tel GmbH</option>
                            <option value="WOBCOM GmbH Wolfsburg">WOBCOM GmbH Wolfsburg</option>
                            <option value="Younip Telecom GmbH">Younip Telecom GmbH</option>
                            <option value="HFO Telecom">HFO Telecom</option>
                        </select>
                        {hoveredField === 'loosingCarrier' && (
                            <div className="hover-description">
                                Choose the necessary action
                            </div>
                        )}
                    </Col>

                </Container>

                <br></br><br></br>

                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Button variant="primary" type="button" onClick={save}>Save</Button>
                    <LoadingButton
                        variant="primary"
                        type="submit"
                        onClick={Submit}
                        isLoading={generateLoading}
                    >
                        Generate LOA
                    </LoadingButton>
                    <Button variant="primary" type="reset" onClick={Reset} style={{ marginRight: '20px' }}>Reset</Button>
                </div>
            </div>

        </div>
    );
}

export default Germany;